import { inject, Injectable } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { firstValueFrom } from 'rxjs';
import { RequestRevisionModalComponent, RequestRevisionModalData } from 'app/app-modules/modal';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class RequestRevisionModalService {
    private readonly _dialogService = inject(DialogService);
    private readonly _translateService = inject(TranslateService);

    async open({ data }: { data: RequestRevisionModalData }) {
        return await firstValueFrom(
            this._dialogService.open(RequestRevisionModalComponent, {
                data,
                // width: '85vw',
                // height: '90vh',
                showHeader: true,
                header: await firstValueFrom(this._translateService.get('general.requestRevision')),
                modal: true,
                closable: true,
                closeOnEscape: true,
            }).onClose
        );
    }
}
